<template>
  <div class="timeline">
    <div class="time" v-for="item in list" :key="item.title" @click="onTitle(item)">
      <div class="time-left">
        <span>{{ item.time | date }}</span>
        <img src="../img/arr.png" alt="">
      </div>
      <div class="time-right">
        <div class="time-content">
          <div class="triangle" :style="'border-top-color:' + item.color"></div>
          <div class="title" :style="'background:' + item.color">
            {{ item.title }}
            <img src="../img/icon_image.svg" alt="" srcset="" v-if="item.image">
            <img src="../img/icon_video.svg" alt="" srcset="" v-if="item.video">
          </div>
        </div>
      </div>
    </div>
    <div class="intro" v-if="info.title" @click="onInfo">
      <video :src="info.video" v-if="info.video" autoplay controls></video>
      <img :src="info.image" v-if="info.image" alt="">
      <div v-html="info.intro || info.title"></div>
      <img src="../img/back.png" class="close" alt="">
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      info: {}
    }
  },
  props: {
    menu: Array,
    list: Array
  },
  filters: {
    date(value) {
      return moment(value).format('M月D日');
    }
  },
  methods: {
    onTitle(info) {
      this.info = info;
      window.navigator.vibrate(300);
    },
    onInfo() {
      this.info = {};
    }
  }
}
</script>

<style lang="less" scoped>
.timeline .time:last-child {
  .time-right {
    padding-bottom: 0;
  }
}
.time {
  display: flex;
  font-size: 3.6vw;
  width: 90%;
  margin: 0 auto;
  :hover {
    opacity: .9;
  }
  .time-left {
    color: #3e4a9a;
    width: 17vw;
    display: flex;
    justify-content: space-between;
    flex-shrink: 0;
    font-weight: 600;
    img {
      width: 2.66vw;
      height: 3.2vw;
      position: absolute;
      margin-left: 16vw;
    }
  }
  .time-right {
    padding: 0 0 4.5vw 5vw;
    border-left: 1px solid #3e4a9a;
    .time-content {
      display: flex;
      .triangle {
        width: 0;
        height: 0;
        border-top: 1.6vw solid #8c8c8c;
        border-left: 1.6vw solid transparent;
      }
      .title {
        background: #8c8c8c;
        color: white;
        padding: 2.0vw;
        box-sizing: border-box;
        border-top-right-radius: .7vw;
        border-bottom-left-radius: .7vw;
        border-bottom-right-radius: .7vw;
        line-height: 1.4em;
        display: inline-block;
        vertical-align: middle;
        img {
          width: 4.0vw;
          height: 4.0vw;
          vertical-align: middle;
          line-height: 1.0em;
        }
      }
    }
  }
}
.intro {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, .95) url('../img/intro_bg.jpg');
  background-size: 100%;
  flex-direction: column;
  video {
    width: 100%;
  }
  img {
    width: 100%;
  }
  div {
    font-size: 4vw;
    color: #333333;
    padding: 5vw;
    box-sizing: border-box;
    line-height: 1.4em;
  }
  .close {
    width: 12vw;
    height: 12vw;
    display: table;
    position: fixed;
    bottom: 10vw;
  }
}
</style>